import Vue from 'vue'
import Router from 'vue-router'
import IpAuthPage from '@/components/IpAuthPage'
import OrderGrabTool from '@/components/OrderGrabTool'
import ipAuthService from '@/services/ipAuthService'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'IpAuth',
      component: IpAuthPage,
      meta: {
        title: 'IP授权验证',
        requiresAuth: false
      }
    },
    {
      path: '/main',
      name: 'OrderGrabTool',
      component: OrderGrabTool,
      meta: {
        title: '怪兽三角洲抢单工具',
        requiresAuth: true
      }
    },
    {
      // 重定向所有未匹配的路由到IP验证页面
      path: '*',
      redirect: '/'
    }
  ]
})

// 路由守卫 - 检查IP验证状态
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  
  // 如果目标路由需要验证
  if (to.meta.requiresAuth) {
    const isAuthenticated = ipAuthService.getAuthStatus()
    
    if (!isAuthenticated) {
      next('/')
      return
    }
  }
  
  // 如果已验证用户访问验证页面，直接跳转到主页面
  if (to.path === '/' && ipAuthService.getAuthStatus()) {
    next('/main')
    return
  }
  
  next()
})

// 监听验证失败事件，强制F5刷新跳转
ipAuthService.on('failed', () => {
  if (router.currentRoute.path !== '/') {
    // 使用最强力的F5刷新逻辑，强制跳转到根路径
    window.location.replace(window.location.origin + '/#/')
    // 如果上面不行，直接刷新页面
    setTimeout(() => {
      window.location.reload(true)
    }, 100)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js